import { PaginationCriteria } from '../../foundation'
import { asBuilder } from '../asBuilder'

export const getPaginationCriteria = asBuilder(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (): PaginationCriteria<any> => ({
    pagination: {
      pageSize: 10,
      pageIndex: 0,
    },
    filter: {},
    sort: {
      orders: [
        {
          fieldName: 'id',
          direction: 'DESC',
        },
      ],
    },
  }),
)
